import { QueryHookOptions, useQuery } from 'react-apollo';
import { LIST_PAGES_QUERY } from './list-pages-query';
import { ListPagesData } from './list-pages-data';
import { ListPagesVariables } from './list-pages-variables';

export const useListPagesQuery = (
  variables: ListPagesVariables,
  options?: Omit<
    QueryHookOptions<ListPagesData, ListPagesVariables>,
    'variables' | 'query'
  >,
) =>
  useQuery<ListPagesData, ListPagesVariables>(LIST_PAGES_QUERY, {
    ...options,
    variables,
  });
